import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = {
  role: "list",
  class: "flex-wrap lg:flex-nowrap flex items-center space-x-1"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  class: "h-5 w-5 flex-shrink-0 text-gray-700",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "text-sm"
}


// name the component
	const __default__ = { name: 'TwBreadcrumb' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		style: {
			type: String,
			default: 'slashes'
		},
		crumbs: {
			type: Array,
			default: () => {return []}
		},
		closeModal:{
			type: Function,
			default: () => {return}
		}
	},
  setup(__props) {

	// eslint-disable-next-line
	const props = __props
  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.crumbs, (crumb, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: crumb.label
        }, [
          _createElementVNode("div", _hoisted_3, [
            (__props.style == 'slashes' && i != 0)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true),
            (crumb.to)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: _normalizeClass(["font-medium text-sm", {'ml-1': i != 0, 'link': __props.crumbs.length > 0 && i != __props.crumbs.length - 1}]),
                  to: crumb.to,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(crumb.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(crumb.label), 1))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})